(app => {

    app.service("pipelineModalService",
        [
            "$mdDialog", function($mdDialog) {
                const defaults = {
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                };

                this.openAddPipeline = ($event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Marketing/PipelineModalService/AddPipeline/add-pipeline.html",
                        controller: "addPipelineController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(alert);
                }

                this.openAddEnrollment = (pipeline, pipe, currentUser, client, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Marketing/PipelineModalService/AddEnrollment/add-enrollment.html",
                        controller: "addEnrollmentController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            pipeline,
                            pipe,
                            currentUser,
                            client,
                        },
                        resolve: {
                            states: ["_states", states => states],
                            clientTypes: ["clientApi", clientApi => clientApi.getClientTypes()]
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openEditEnrollment = (pipeline, pipe, enrollment, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Marketing/PipelineModalService/EditEnrollment/edit-enrollment.html",
                        controller: "editEnrollmentController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            pipeline,
                            pipe,
                            enrollment,
                        },
                        resolve: {
                            clientTypes: ["clientApi", clientApi => clientApi.getClientTypes()],
                            clientDetails: ["clientApi", clientApi => clientApi.get(enrollment.ClientId)]
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.confirmPipelineDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this pipeline?",
                        ariaLabel: "Confirm pipeline deletion",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event
                    });

                    return $mdDialog.show(confirm);
                }

                this.confirmPipeDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        theme: "confirmDelete",
                        title: "Are you sure you want to remove this pipe? All clients currently in this pipe will also be removed from the pipeline.",
                        ariaLabel: "Confirm pipe deletion",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(confirm);
                }

                this.confirmEnrollmentDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        theme: "confirmDelete",
                        title: "Are you sure you want to remove this contact from the pipeline?",
                        ariaLabel: "Confirm contact removal",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(confirm);
                }
            }
        ]);

})(window.app);